import { Tag } from 'situview-webapi-client';
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TaggingService } from 'src/app/services';

@Component({
  selector: 'edit-tag.component',
  templateUrl: 'edit-tag.component.html',
  styleUrls: ['edit-tag.component.scss'],
})

export class EditTagComponent implements OnInit {
  form: FormGroup;

  public background(index: string) {
    return this.taggingService.tagBackgroundColourClassName(index);
  }

  public border(index: string) {
    return this.taggingService.tagBorderColourClassName(index);
  }

  public get borderColour(): string {
    return this.form.get("colour")?.value
  }

  public set borderColour(value: string | undefined) {
    this.form.get("colour")?.setValue(value ?? "1");
  }

  public get backgroundColour(): string {
    return this.form.get("backgroundColour")?.value;
  }

  public set backgroundColour(value: string | undefined) {
    this.form.get("backgroundColour")?.setValue(value ?? "3");
  }

  constructor(
    private taggingService: TaggingService,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<EditTagComponent>,
    @Inject(MAT_DIALOG_DATA) public tag: Tag,
  ) {
    this.form = this.formBuilder.group({
      name: [],
      colour: [],
      backgroundColour: [],
    });
  }

  ngOnInit(): void {
    this.form.get("name")?.setValue(this.tag.name);
    this.borderColour = this.tag.borderColour ?? "1";
    this.backgroundColour = this.tag.backgroundColour ?? "3";
  }

  close(): void {
    this.dialogRef.close();
  }

  onDeleteClick(): void {
    if (confirm("Are you sure you wish to delete this tag?")) {
      this.taggingService.deleteTag(this.tag.id ?? "")
    }
    close();
  }

  onSubmit(): void {
    this.dialogRef.close();
    this.taggingService.updateTag(this.tag.id ?? "",
      this.backgroundColour,
      this.borderColour,
      this.form.get("name")?.value);
  }

  setBorderColour(val: string) {
    this.borderColour = val;
  }

  setBackgroundColour(val: string) {
    this.backgroundColour = val;
  }
}
